import React from "react";

import { TypographyBlock } from "../../../../../../wsui/base";

export default function TextContent({ children, ...restProps }) {
  return <TypographyBlock {...restProps}>{children}</TypographyBlock>;
}
